module.exports = __webpack_public_path__ + "static/media/rfb_testimonial4_runseries.12a8abf0.jpg";